import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
declare var $: any;
@Component({
  selector: 'app-sidebar-overlay',
  templateUrl: './sidebar-overlay.component.html'
})
export class SidebarOverlayComponent implements OnInit {
  @Input() sidebar: any;
  language: any;
  mini: boolean = true;
  screenWidth: any = '';
  screenHeight: any = '';
  constructor(private translate: TranslateService) {
    translate.addLangs(['en', 'fr', 'it', 'ja']);
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.screenWidth = window.screen.width;
    this.screenHeight = window.screen.height;
  }

  collapseSidebar() {
    if (this.mini) {
      if (this.screenWidth >= 992 && this.screenWidth <= 1024) {
        $("#mySidebar").css({ 'width': "240px" });
      } else {
        $("#mySidebar").css({ 'width': "250px" });
      }
      $("#mySidebar a span").css('display', "block");
      $(".q-logo2").css('display', "none");
      $(".q-logo1").css('display', "block");
      $("#overlay").css({ 'background': "rgba(0,0,0,0.5)", 'width': '100%' });

      this.mini = false;
    } else {
      $("#overlay").css({ 'background': "none", 'width': '0' });
      $("#mySidebar").css('width', "85px");
      $("#mySidebar a span").css('display', "none");
      $(".q-logo1").css('display', "none");
      $(".q-logo2").css('display', "block");

      this.mini = true;
    }

  }

}
